"use strict";module.exports = require("@internal/preserve-tag");